import { axiosClient } from "services/client";
import {
  APPROVE_PACK_LESSON,
  APPROVE_SINGLE_LESSON,
  CANCEL_RESERVATION_GROUP_SINGLE_AND_PACK,
  CANCEL_RESERVATION_INDIVIDUAL_PACK,
  CANCEL_RESERVATION_INDIVIDUAL_SINGLE,
  GET_ALL_SCHEDULES,
  GET_ENROLLMENTS_GROUP_PACK,
  GET_ENROLLMENTS_GROUP_SINGLE,
  GET_RESERVATIONS_GROUP,
  GET_RESERVATIONS_INDIVIDUAL,
  GET_USER_TOTAL_POINTS,
  GROUP_LESSONS_RESERVATION_STUDENT_LIST,
  RATE_PACK,
  RATE_SINGLE,
  REFUND_INDIVIDUAL_PACK,
  REFUND_INDIVIDUAL_SINGLE,
  REJECT_PACK_LESSON,
  REJECT_RESERVATION_GROUP_SINGLE_AND_PACK,
  REJECT_RESERVATION_INDIVIDUAL_PACK,
  REJECT_RESERVATION_INDIVIDUAL_SINGLE,
  REQUEST_RESERVATION_SCHEDULE_CHANGE,
  RESCHEDULE_INDIVIDUAL_PACK,
  RESCHEDULE_INDIVIDUAL_SINGLE,
  RESERVED_LESSONS_GET,
  SEND_LESSON_REPORT_GROUP_PACK,
  SEND_LESSON_REPORT_GROUP_SINGLE,
  SEND_LESSON_REPORT_INDIVIDUAL_SINGLE,
  STUDENT_RESERVATION_GROUP_PACK,
  STUDENT_RESERVATION_GROUP_SINGLE,
  STUDENT_RESERVATION_INDIVIDUAL_PACK,
  STUDENT_RESERVATION_INDIVIDUAL_SINGLE,
  TEACHER_RESERVATION_ACTION,
  TEACHER_SUBMIT_REPORT,
} from "services/client/endpoints";
import {
  IRatePayloadPack,
  IRatePayloadSingle,
} from "../types/redux/reservation";
import {
  GroupLessonsStudent,
  getGroupLessonsStudentPayload,
  reservationActionPayload,
  submitReportPayload,
} from "./service-models/reservations";

const ReservationsService = {
  getIndividualReservations: async (data: any): Promise<any> => {
    try {
      const res = await axiosClient.post<any>(
        GET_RESERVATIONS_INDIVIDUAL,
        data
      );
      return res.data.data;
    } catch (err) {
      return [];
    }
  },

  getGroupReservations: async (data: any): Promise<any> => {
    try {
      const res = await axiosClient.post<any>(GET_RESERVATIONS_GROUP, data);
      return res.data.data;
    } catch (err) {
      return [];
    }
  },

  approveSingleLesson: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(APPROVE_SINGLE_LESSON, data);
    return res.data;
  },

  approvePackLesson: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(APPROVE_PACK_LESSON, data);
    return res.data;
  },
  rejectPackLesson: async (data: any): Promise<any> => {
    try {
      const res = await axiosClient.post<any>(REJECT_PACK_LESSON, data);
      return res.data;
    } catch (err) {
      return null;
    }
  },

  // * reject reservations - individual - single
  rejectReservationIndividualSingle: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(
      REJECT_RESERVATION_INDIVIDUAL_SINGLE,
      data
    );
    return res.data;
  },
  // * reject reservations - individual - pack
  rejectReservationIndividualPack: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(
      REJECT_RESERVATION_INDIVIDUAL_PACK,
      data
    );
    return res.data;
  },
  // * reject reservations - group - single and pack
  rejectReservationGroupSingleAndPack: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(
      REJECT_RESERVATION_GROUP_SINGLE_AND_PACK,
      data
    );
    return res.data;
  },

  // * student reservation - group - pack
  studentReserveGroupPack: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(
      STUDENT_RESERVATION_GROUP_PACK,
      data
    );
    return res;
  },
  // * student reservation - group - single
  studentReserveGroupSingle: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(
      STUDENT_RESERVATION_GROUP_SINGLE,
      data
    );
    return res;
  },

  // * student reservation - individual - single
  studentReserveIndividualSingle: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(
      STUDENT_RESERVATION_INDIVIDUAL_SINGLE,
      data
    );
    return res;
  },
  // * student reservation - individual - pack
  studentReserveIndividualPack: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(
      STUDENT_RESERVATION_INDIVIDUAL_PACK,
      data
    );
    return res;
  },

  // * get expert schedule
  getExpertSchedule: async (data: any): Promise<any> => {
    const res = await axiosClient.get<any>(
      `${GET_ALL_SCHEDULES}?expert_id=${data}`
    );
    return res.data.data;
  },
  // * get user total points
  getUserTotalPoints: async (): Promise<any> => {
    const res = await axiosClient.get<any>(GET_USER_TOTAL_POINTS);
    return res.data.data.points;
  },

  // * send lesson report - individual - single
  sendLessonReoprtIndividualSingle: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(
      SEND_LESSON_REPORT_INDIVIDUAL_SINGLE,
      data
    );
    return res.data;
  },
  // * send lesson report - group - single
  sendLessonReoprtGroupSingle: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(
      SEND_LESSON_REPORT_GROUP_SINGLE,
      data
    );
    return res.data;
  },
  // * send lesson report - group - pack
  sendLessonReoprtGroupPack: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(
      SEND_LESSON_REPORT_GROUP_PACK,
      data
    );
    return res.data;
  },

  // * get enrollments - group - single
  getEnrollmentsGroupSingle: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(GET_ENROLLMENTS_GROUP_SINGLE, data);
    return res.data;
  },
  // * get enrollments - group - pack
  getEnrollmentsGroupPack: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(GET_ENROLLMENTS_GROUP_PACK, data);
    return res.data;
  },

  // * cancel reservations
  cancelReservationGroupSingleAndPack: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(
      CANCEL_RESERVATION_GROUP_SINGLE_AND_PACK,
      data
    );
    return res.data;
  },
  cancelReservationIndividualPack: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(
      CANCEL_RESERVATION_INDIVIDUAL_PACK,
      data
    );
    return res.data;
  },
  cancelReservationIndividualSingle: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(
      CANCEL_RESERVATION_INDIVIDUAL_SINGLE,
      data
    );
    return res.data;
  },

  // * reschedule reservations - individual - single
  rescheduleIndividualSingle: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(RESCHEDULE_INDIVIDUAL_SINGLE, data);
    return res.data;
  },
  // * reschedule reservations - individual - pack
  rescheduleIndividualPack: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(RESCHEDULE_INDIVIDUAL_PACK, data);
    return res.data;
  },
  // * refund reservations - individual - single
  refundIndividualSingle: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(REFUND_INDIVIDUAL_SINGLE, data);
    return res.data;
  },
  // * refund reservations - individual - group
  refundIndividuaGroup: async (data: any): Promise<any> => {
    const res = await axiosClient.post<any>(REFUND_INDIVIDUAL_PACK, data);
    return res.data;
  },
  rateSingleReservation: async (data: IRatePayloadSingle): Promise<any> => {
    const res = await axiosClient.post<any>(RATE_SINGLE, data);
    return res.data;
  },
  ratePackReservation: async (data: IRatePayloadPack): Promise<any> => {
    const res = await axiosClient.post<any>(RATE_PACK, data);
    return res.data;
  },
  // Teacher reservation

  getReservedLessons: async (): Promise<any> => {
    const response = await axiosClient.get<any>(RESERVED_LESSONS_GET);
    return response.data;
  },

  reservationScheduleChangeRequest: async (
    reservation_id: number
  ): Promise<any> => {
    const response = await axiosClient.post<any>(
      `${REQUEST_RESERVATION_SCHEDULE_CHANGE}?reservation_id=${reservation_id}`
    );
    return response.data.data;
  },

  teacherAcceptOrRejectReservation: async (
    data: reservationActionPayload
  ): Promise<any> => {
    const response = await axiosClient.post<any>(
      TEACHER_RESERVATION_ACTION,
      data
    );
    return response.data.data;
  },

  teacherSubmitReport: async (data: submitReportPayload): Promise<any> => {
    const response = await axiosClient.post<any>(TEACHER_SUBMIT_REPORT, data);
    return response.data.data;
  },

  getGroupLessonsReservationStudentList: async (
    data: getGroupLessonsStudentPayload
  ): Promise<GroupLessonsStudent[]> => {
    const response = await axiosClient.post<{ data: GroupLessonsStudent[] }>(
      GROUP_LESSONS_RESERVATION_STUDENT_LIST,
      data
    );
    return response.data.data;
  },
};

export default ReservationsService;
